import { reset, setError } from '@/entities/purchase-form';
import { ROOT_CART_SUBMIT_ERROR_KEY } from '@/widgets/product-details/purchase-panel/model/useHasOnlyCartSubmitError';
import { useOnError } from '@/widgets/product-details/purchase-panel/model/useOnError';

export const useAddToCartOnError = () => {
    const { onError } = useOnError();

    const onAddToCartError = (error: Error) => {
        // Set root level error to prevent success message
        setError(ROOT_CART_SUBMIT_ERROR_KEY, { type: 'submit', message: error.message });

        // Reset form state immediately to prevent button disablement during the 3 second window before the success path reset occurs
        reset(undefined, { keepIsSubmitted: false, keepValues: true, keepErrors: true });

        onError(error);
    };

    return { onAddToCartError };
};
